import React, { useState } from 'react';
import {
  OverlayTrigger,
  Tooltip,
  Modal,
  Button,
  Form,
  Alert,
} from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { GetEmailDto } from '../../../common/spdCore/autogenerated/spdApiClient';

export const EmailResendLinkWithOverride = (props: {
  emailId: string;
  email: GetEmailDto;
  setRefresh?: () => void;
  setLoading?: (loading: boolean) => void;
}) => {
  const [showModal, setShowModal] = useState(false);
  const [overrideEmail, setOverrideEmail] = useState<string>(
    props.email?.examined?.email ? props.email?.examined.email || '' : '',
  );
  const spd = useSpdCore();

  const handleModalOpen = () => {
    setOverrideEmail(
      props.email?.examined?.email ? props.email?.examined.email || '' : '',
    );
    setShowModal(true);
  };

  const handleResendWithOverride = () => {
    if (props.setLoading) {
      props.setLoading(true);
    }
    spd.emails
      .resend(props.emailId, overrideEmail || undefined)
      .then(() => {
        if (props.setRefresh) {
          props.setRefresh();
        }
        if (props.setLoading) {
          props.setLoading(false);
        }
        setShowModal(false);
      })
      .catch(error => {
        console.log(
          `Wystąpił problem z ponownym wysłaniem wiadomości e-mail. ${error}`,
        );
        if (props.setLoading) {
          props.setLoading(false);
        }
      });
  };

  return (
    <>
      <Button variant="link" className="ms-1" onClick={handleModalOpen}>
        <OverlayTrigger
          overlay={
            <Tooltip style={{ position: 'fixed' }}>
              Ponowne wysłanie do innego adresu
            </Tooltip>
          }
        >
          <Icon.EnvelopePlus size={16} />
        </OverlayTrigger>
      </Button>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        backdropClassName="modal-on-modal-backdrop"
        className="modal-on-modal"
      >
        <Modal.Header>
          <Modal.Title>Ponowne wysłanie wiadomości e-mail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="info">
            Wiadomość e-mail będzie ponownie wysłana tylko na wskazane poniżej
            adresy.
          </Alert>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Adresy e-mail odbiorców</Form.Label>
              <Form.Control
                type="text"
                value={overrideEmail}
                onChange={e => setOverrideEmail(e.target.value)}
              />
              <Form.Text className="text-muted">
                Wiele adresów oddziel przecinkami
              </Form.Text>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => setShowModal(false)}
          >
            Anuluj
          </Button>
          <Button variant="outline-success" onClick={handleResendWithOverride}>
            Wyślij
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
